<template>
  <RegisterForm :isApplicationRegister="true" :registerLandingId="registerLandingId" :registerApplicationId="registerApplicationId" />
</template>

<script>
import RegisterForm from '@/components/frontend/Pages/Auth/RegisterForm';
import { resolveRegisterLandingUrl } from '@/helpers/registerLanding';

export default {
  components: { RegisterForm },
  layout: 'frontend/auth',
  async asyncData ({ app, store, route, from, $frontendRepositories}) {
    await store.dispatch('admin/companies/getBusiness');
    await store.dispatch('particles/province/getList');

    let registerLandingId = null;
    let registerApplicationId = null;
    const registerLandingUrl = resolveRegisterLandingUrl({ app, route, from });

    if (registerLandingUrl) {
      const { errResponse, data: responseData } = await $frontendRepositories.landing.showPublic(registerLandingUrl);
      if (!errResponse) {
        registerLandingId = responseData.data.id;
        registerApplicationId = responseData.data.application_id;
      }
    }
    return {
      registerLandingId,
      registerApplicationId,
      registerLandingUrl
    };
  },
  async mounted() {
    // SSR cannot read the tab's sessionStorage. Reconcile it after hydration.
    const registerLandingUrl = resolveRegisterLandingUrl({
      app: this,
      route: this.$route
    });
    if (registerLandingUrl === this.registerLandingUrl) {
      return;
    }

    this.registerLandingUrl = registerLandingUrl;
    this.registerLandingId = null;
    this.registerApplicationId = null;
    if (registerLandingUrl) {
      const { errResponse, data: responseData } = await this.$frontendRepositories.landing.showPublic(registerLandingUrl);
      if (!errResponse) {
        this.registerLandingId = responseData.data.id;
        this.registerApplicationId = responseData.data.application_id;
      }
    }
  },
  head() {
    return {
      title: 'アカウント登録'
    }
  },
}
</script>
